import type { HTMLProps } from 'react'
import React, { useMemo } from 'react'
import * as icons from '@ant-design/icons'
import { omit } from 'lodash'

interface Props extends HTMLProps<HTMLSpanElement> {
  type: string,
  size?: number,
  defaultIcon?: string,
  allowBlank?: boolean,
  iconSource?: any,
}

const EasyIcon = (props: Props) => {
  const aliIcons = useMemo(() => {
    const { iconSource = require('src/styles/fonts/iconfont.json') } = props
    if (!iconSource) return []

    const { css_prefix_text, glyphs } = iconSource
    return glyphs.map((item: any) => `${css_prefix_text}${item.font_class}`)
  }, [props.iconSource])

  const fontIcon = useMemo(() => {
    const typeIcon = aliIcons.find((icon: string) => icon === props.type)
    return typeIcon ?? aliIcons.find((icon: string) => icon === props.defaultIcon)
  }, [props.type, props.defaultIcon])

  const antdIcon = useMemo(() => {
    const ics = icons as any
    if (ics[props.type]) return ics[props.type]
    if (props.defaultIcon && ics[props.defaultIcon]) {
      return ics[props.defaultIcon]
    }
    if (!props.allowBlank) return ics['SettingOutlined']
    return () => null
  }, [props.type])

  const presetStyle = useMemo(() => {
    return Object.assign({}, props.size ? { fontSize: props.size } : {}, props.style)
  }, [props.size, props.style])

  const validSpanProps = omit(props, ['defaultIcon', 'allowBlank', 'iconSource'])
  if (fontIcon) {
    return <i {...validSpanProps} className={`iconfont ${fontIcon} ${props.className}`} style={{ lineHeight: 1, ...presetStyle }} />
  }

  return React.createElement(antdIcon, { ...validSpanProps, style: presetStyle })
}

EasyIcon.defaultProps = {
  allowBlank: false
}

export default EasyIcon